export default {
  showStages: 'Zobraziť fázy',
};
